import React, {useEffect, useState} from "react";
import {Body1,} from "../../../components/Font";
import {
    CardContainer,
    ContentContainer,
    ContentNotification,
    FlexRow,
    NotificationList,
} from "../../../components/ui/Content";
import {ModalContent} from "./ModalContent";
import {useAppSelector} from "../../../app/hooks";
import {InfoModalContent} from "./InfoModalContent";
import {WarningModal} from "../../../ui/Modal/WarningModal";
import {UserInfoCard} from "./UserInfo/UserInfo";
// import {IdentityCardInfo} from "./IdentityCardInfo";
// import {SocialNumberInfo} from "./SocialNumberInfo";
import {LargeInfo} from "../../../icon/Icon";
import {IdentityCardInfo} from "./IdentityCardInfo";
import {SocialNumberInfo} from "./SocialNumberInfo";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";
import {useTheme} from "styled-components";
import { ExternalAccounts } from "./ExternalAccounts/ExternalAccounts";
import { ExternalAccount } from "../../../interface/Passport/Account/frontend";
import { ExAccInfoModal } from "./Modals/ExAccInfoModal";

export enum CurrentModalEnum {
    Personal = 'Персональная информация',
    Citizenhsip = 'Гражданство',
    Passport = 'Удостоверение личности',
    SocialNumber = 'СНИЛС',
}

export interface IMessages {
    error: {
        messages: string[],
        status: 'error'
    },
    success:{
        messages: string[],
        status: 'success'
    }
}

export const AccountInfo = () => {

    const account = useAppSelector(state => state.account)
    // const {registered} = useAppSelector(state => state.auth)
    const notification = [
        'У вас упрощённая учётная запись. Вам доступны только гостевые сервисы и услуги. Чтобы открыть больше сервисов и услуг, заполните профиль и подтвердите документы. ',
    ]

    // const verify_notification = [
    //     'Профиль заполнен. Чтобы  получить доступ ко всем услугам осталось только подтвердить документы.',
    // ]

    const theme = useTheme()
    const [currentModal, setCurrentModal] = useState<CurrentModalEnum | null>(null)
    const [currentInfoModal, setCurrentInfoModal] = useState<CurrentModalEnum | null>(null)
    const [warningModal, setWarningModal] = useState<CurrentModalEnum | null>(null)
    const [isModalInfoOpen, setIsModalInfoOpen] = useState(false)

    useEffect(() => {
        // if (registered) {
        setCurrentModal(CurrentModalEnum.Personal)
        // }
    }, [])
    useEffect(() => {
        // if (registered) {
        setCurrentModal(CurrentModalEnum.Personal)
        // }
    }, [])
    useEffect(() => {
        setCurrentInfoModal(null)
        setCurrentModal(null)
        setWarningModal(null)
    }, [account.tabClick])

    // useEffect(() => {
    //     if (!registered) {
    //         setCurrentModal(null)
    //     }
    // }, [account.personalInfo, account.passport, account.foreign_passport, account.socialNumber])

    const initialState: IMessages = {
        error: {
            messages: [],
            status: 'error'
        },
        success: {
            messages: [],
            status: 'success'
        }
    }

    const [messages, setMessages] = useState<IMessages>(initialState)
    const [isExAccErrorModal, setIsExAccErrorModal] = useState<boolean>(false)
    const [isExAccSuccessModal, setIsExAccSuccessModal] = useState<boolean>(false)

    useEffect(() => {
        const data = account.externalAccountsData?.data

        if (!data) return

        const messages = getMessages()

        if (messages.error.messages.length || messages.success.messages.length) {
            setMessages(messages)

            if (messages.error.messages.length) {
                setIsExAccErrorModal(true)
            }

            if (messages.success.messages.length) {
                setIsExAccSuccessModal(true)
            }
        }
        
    }, [account.externalAccountsData?.data])

    const getMessages = () => {
        const data = account.externalAccountsData?.data
        
        const messages:IMessages = {
            error: {
                messages: [], 
                status: 'error'
            },
            success: {
                messages: [],
                status: 'success'
            }
        }

        if (data?.length) {
            data.forEach((item: ExternalAccount) => {
                if(item.message.error) {
                    messages.error.messages.push(item.message.error)
                }

                if(item.message.success) {
                    messages.success.messages.push(item.message.success)
                }
            })
        }

        return messages
    }

    return <ContentContainer>
        {isExAccErrorModal && <ExAccInfoModal messages={messages} status="error" onClose={() => setIsExAccErrorModal(false)}/>}
        {isExAccSuccessModal && <ExAccInfoModal messages={messages} status="success" onClose={() => setIsExAccSuccessModal(false)}/>}
        {warningModal &&
        <WarningModal
            onClose={() => {
                setIsModalInfoOpen(true)
                setCurrentInfoModal(warningModal)
                setCurrentModal(null)
                setWarningModal(null)
            }}
            onSubmit={() => {
                setCurrentInfoModal(null)
                setCurrentModal(currentInfoModal)
                setWarningModal(null)
            }}/>}

        {currentInfoModal &&
        (<InfoModalContent
            onGoEdit={() => {
                if (((currentInfoModal === CurrentModalEnum.Passport || currentInfoModal === CurrentModalEnum.Personal)
                        && ((account.passport?.is_verified || account.foreign_passport?.is_verified)
                            && !(account.passport?.isOutdated || account.foreign_passport?.isOutdated)))
                    || (currentInfoModal === CurrentModalEnum.SocialNumber && account.socialNumber?.is_verified)
                ) {
                    setWarningModal(currentInfoModal)
                }
            }}
            onGoBack={() => {
                setIsModalInfoOpen(false)
                setCurrentInfoModal(null)
            }}
            onGoEditProfile={() => {
                setCurrentInfoModal(null)
                setCurrentModal(CurrentModalEnum.Personal)
            }}

            currentInfoModal={currentInfoModal}/>)
        ||
        <>
            {currentModal
                ? <ModalContent
                    isInfoModalOpen={isModalInfoOpen}
                    onGoInfoModal={() => {
                        setIsModalInfoOpen(true)
                        setCurrentInfoModal(currentModal)
                    }}
                    onGoBack={() => {
                        setCurrentModal(null)
                    }} currentModal={currentModal}/>
                : account.isFetching ? <LoaderContainer style={{height: '200px'}}>
                            <MiniLoader color={theme.color.indicator} size={LoaderEnum.medium}/>
                        </LoaderContainer>
                        : <>
                    {((!account.passport || !account.foreign_passport) && !account.socialNumber) &&
                    <ContentNotification>
                        <NotificationList>
                            <FlexRow style={{gap: '12px'}}>
                                <LargeInfo/>
                                <Body1>{notification}</Body1>
                            </FlexRow>
                        </NotificationList>
                    </ContentNotification>}
                    <UserInfoCard
                        isIdentityCardVerified={account.passport?.is_verified || account.foreign_passport?.is_verified}
                        goToProfileInfo={() => {
                            setIsModalInfoOpen(true)
                            setCurrentInfoModal(CurrentModalEnum.Personal)
                        }}
                        goToEditProfile={() => setCurrentModal(CurrentModalEnum.Personal)}
                        isVerified={(account.passport?.is_verified || account.foreign_passport?.is_verified)}
                    />

                    <ExternalAccounts/>

                    {/* уведомление что надо подтвердить свои данные через госуслуги */}
                    {/*{(((account.passport && !account.passport.is_verified) || (account.foreign_passport && !account.foreign_passport.is_verified))*/}
                    {/*    || (account.socialNumber && !account.socialNumber.is_verified))*/}
                    {/*&& <ContentNotification>*/}
                    {/*    <NotificationList>*/}
                    {/*        <FlexRow style={{gap: '12px'}}>*/}
                    {/*            <div>*/}
                    {/*                <Info/>*/}
                    {/*            </div>*/}
                    {/*            <FlexColumn>*/}
                    {/*                <Body1>{verify_notification}</Body1>*/}
                    {/*                <VerifyButtonsContent>*/}
                    {/*                    <VerifyButton><Body1>Подтвердить на портале госуслуг</Body1></VerifyButton>*/}
                    {/*                    <VerifyButton><Body1>Записаться на приём в МФЦ</Body1></VerifyButton>*/}
                    {/*                </VerifyButtonsContent>*/}
                    {/*            </FlexColumn>*/}
                    {/*        </FlexRow>*/}
                    {/*    </NotificationList>*/}
                    {/*</ContentNotification>*/}
                    {/*}*/}
                    <CardContainer>
                        <IdentityCardInfo
                            openModalInfo={() => {
                                setIsModalInfoOpen(true)
                                setCurrentInfoModal(CurrentModalEnum.Passport)
                            }}
                            goToEditIdentityCard={() => setCurrentModal(CurrentModalEnum.Passport)}
                        />

                        <SocialNumberInfo
                            openModalInfo={() => {
                                setIsModalInfoOpen(true)
                                setCurrentInfoModal(CurrentModalEnum.SocialNumber)
                            }}
                            goToEditSocialNumber={() => setCurrentModal(CurrentModalEnum.SocialNumber)}
                        />
                    </CardContainer>
                    {/*{ (account.passport?.is_verified || account.foreign_passport?.is_verified) && account.socialNumber?.is_verified &&*/}
                    {/*    <AdditionalInfoContainer>*/}
                    {/*        <WorkInfoCard/>*/}
                    {/*        <EducationInfoCard/>*/}
                    {/*    </AdditionalInfoContainer>*/}
                    {/*}*/}
                </>}
        </>}
    </ContentContainer>
}